export class NumberUtils {
  private constructor() {}
  public static round(number: number, decimals: number = 0): number {
    const multiplicator = Math.pow(10, decimals);
    return Math.round(number * multiplicator) / multiplicator;
  }
  public static formatCoarseDistance(distanceInMeters: number): string {
    const absoluteDistanceInMeters = Math.abs(distanceInMeters);
    if (absoluteDistanceInMeters < 1000) {
      return `${this.round(absoluteDistanceInMeters, 0)}m`;
    }
    return `${this.round(absoluteDistanceInMeters / 1000, 1)}km`;
  }
}